import React, { ReactElement, FC } from 'react';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import { BaseProps } from 'shared/types/base';
import { theme } from 'theme';
import { useNavigate } from 'react-router-dom';

type NotFoundProps = BaseProps;

const useStyles = makeStyles({
  logo: {
    height: 120,
    marginBottom: theme.spacing(4),
  },
  title: {
    marginBottom: theme.spacing(3),
  },
  button: {
    marginTop: theme.spacing(4),
  },
});

const NotFound: FC<NotFoundProps> = (): ReactElement => {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goBack = () => {
    navigate('/');
  };

  return (
    <Box textAlign="center" marginTop={4}>
      <img src="Scope-TheEuropean-logo.svg" alt="logo" className={classes.logo} />
      <Typography variant="h4" className={classes.title}>
        {t('PAGE_NOT_FOUND')}
      </Typography>
      <Typography variant="body2">
        {t('SORRY_THE_PAGE_YOU_ARE_LOOKING_FOR_WAS_NOT_FOUND')}
      </Typography>
      <Button variant="contained" color="primary" className={classes.button} onClick={goBack}>
        {t('GO_BACK')}
      </Button>
    </Box>
  );
};

export { NotFound };
